export default __webpack_public_path__ + "static/media/goodFridayBottomOrange.a131afcd.png";